__webpack_require__.p = "/mandarin-trainer/";